export default __webpack_public_path__ + "static/intro_mobile_reversed-e2b1c5c5779b3d70d82b09bc8394ebd4.mp4";